import moment from 'moment'
import React, {useState, useEffect, useRef} from 'react'
import firebase from '../firebase/config'
import { useCollectionData } from 'react-firebase-hooks/firestore';
import {useLocation} from 'react-router-dom';

function Messages() {

  const data = useLocation()
  const [user, setUser] = useState({})
  const [selectedChat, setSelectedChat] = useState({})
  const [chats, setChats] = useState([])
  const [aliadoChats, setAliadoChats] = useState([])
  const [messages, setMessages] = useState([])
  const [message, setMessage] = useState(null)
  const hiddenFileInput = React.useRef(null);

  const [file, setFile] = useState(null);
  const [src, setImg] = useState('');

  const dummy = useRef();
  const scrollToBottom = () => {
    dummy.current.scrollIntoView({ behavior: 'smooth' });
  }

  const handleClick = event => {
    hiddenFileInput.current.click();
  };

  function handleChange(e) {
    setImg(URL.createObjectURL(e.target.files[0]))
    setFile(e.target.files[0])
  }
 
  async function getChats(aliadoId){

    let tipos = []

    await firebase.db.collection("Chats").where("aliadoId", "==", aliadoId).get().then((val)=>{
      val.docs.forEach((doc)=>{
        tipos.push(doc.data())
      })
    });
    setAliadoChats(tipos)
    setDueñosInfo(tipos)
    
  }
  
  async function getChatFromClient(aliadoId){
    try{
      await firebase.db.collection("Chats").where("aliadoId", "==", aliadoId).where("uid", "==", data.state.uid).get().then((val)=>{
        val.docs.forEach((doc)=>{
          setSelectedChat(doc.data())
          getMessages(doc.data().chatId)
        })
      })
    }catch(e){
      console.log("Error: " + e)
    }
    
  }
  
  async function setDueñosInfo(list){
    
    await Promise.all(list.map(async (d) => {
      let nombre
      let url
      let lastMessage
      let lastMessageHour
      await firebase.db.collection("Dueños").doc(d.uid).get().then(val=>{
        nombre = val.data().nombre ?? val.data().user 
        url = val.data().url
      })
      await firebase.db.collection("Chats").doc(d.chatId).collection("Mensajes").orderBy("createdOn").get().then(val=>{
        lastMessage = val.docs[val.docs.length - 1].data().message
        lastMessageHour = moment(val.docs[val.docs.length - 1].data().createdOn.toDate()).format("LT")
      })
      d["nombre"] = nombre
      d["url"] = url
      d["lastMessage"] = lastMessage
      d["lastMessageHour"] = lastMessageHour
    }))
    setChats(list)
    // console.log(list)
  }

  async function getMessages(chatId){
    let tipos = [] 
    await firebase.db.collection("Chats").doc(chatId).collection("Mensajes").orderBy("createdOn").get().then(val=>{
      val.docs.forEach((doc)=>{
        tipos.push(doc.data())
      })
    })
    setMessages(tipos)
    // console.log(list)
  }

  useEffect(() => {
    firebase.getCurrentUser().then((val)=>{
      setUser(val)
      getChats(val.aliadoId);
      if(data.state !== undefined && data.state !== null){
        getChatFromClient(val.aliadoId)
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  

    return (
        <div className="main-content-container container-fluid px-4">

          <div className="page-header align-items-center justify-content-spacebetween row no-gutters px-4 my-4">
            <div className="col-12 col-sm-5 text-center text-sm-left mb-0">
              <div className="row align-items-center">
                <div className="col">
                  <p className="page-title"><span>Mensajes</span></p>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-1 mb-0">
              <div className="row align-items-center justify-content-space-around">
                <i className="material-icons color-white display-5">help_outline</i>
              </div>
            </div>
          </div>
            
          <div className="row no-gutters">
            <div className="col-lg-4 h-70vh">
              <div className="h-70vh overflow-y">
                {chats.length > 0 ? chats.map(chat => {
                  return (
                    <div key={chat.chatId} onClick={()=>{ setActiveChat(chat) }}  className={selectedChat === chat ? "chats-container active  px-2" : "chats-container  px-2"}>
                      <div className="">
                        <div className="chats-container-img">
                          <img src={chat.url} alt=""/>
                        </div>
                      </div>
                      <div className="chats-container-text">
                        <p className="chats-container-name">{chat.nombre}</p>
                        <p className="chats-container-msg">{chat.lastMessage}</p>
                      </div>
                      <div className="chats-container-additional">
                        <p className="chats-container-hour">{chat.lastMessageHour}</p>
                      </div>
                    </div>
                  )
                }) : <p className="chats-container-name">No tienes mensajes todavía</p>}
              </div>
            </div>
            <div className={selectedChat.chatId ? "col-lg-8 bg-white border" : "col-lg-8 bg-white border"}>
              <div style={{heigth: "73vh"}}>
                {selectedChat.chatId ? <div className="chat-header">
                  <div className="row no-gutters align-items-center p-2">
                    <div className="chats-container-img">
                      <img src={selectedChat.url} alt=""/>
                    </div>
                    <p className="chats-container-name ml-3 mb-0">{selectedChat.nombre}</p>
                  </div>
                </div> : <div></div>}
                {/* <div className="full-height-margin"></div> */}
                <div className="chat-flow">
                  { selectedChat.chatId ? 
                  messages.map(message => {
                    let hour = message.createdOn.toDate().getHours()
                    let minutes = message.createdOn.toDate().getMinutes()
                    return (
                      <div key={message.createdOn}  className={message.aliadoId !== "" && message.aliadoId !== null ? "message-container-me mr-3" : "message-container-other ml-3"} >
                        <div className={`message-container-info ${message.aliadoId && "flexEnd"}`}>
                          {message.image && <div className="chat-img mb-2"><img src={message.image} alt="" /></div> }
                          {message.message !== '' && <p className="mb-2" >{message.message}</p> }
                          <span className="light">{hour}:{minutes > 10 ? minutes : ("0" + minutes.toString())}</span>
                        </div>
                      </div>
                    )
                  })
                  : <div></div> }
                  <span ref={dummy}></span>
                </div>
                {selectedChat.chatId ? <div className="chat-form">
                  {src !== "" && <div className="chat-img-send">
                    <img src={src} alt="" />
                  </div>
                  }
                  <div className="row no-gutters">
                    <input placeholder="Escribe un mensaje" value={message} onChange={((e)=>{setMessage(e.target.value)})} type="text" className="chat-input-message"/>
                    <div className="row no-gutters">
                        <input type="file"
                          ref={hiddenFileInput}
                          onChange={handleChange} 
                          style={{display: 'none'}}
                        />
                      <span className="cursor-pointer btn btn-outline-secondary" onClick={handleClick}><i style={{fontSize: "18px"}} className="material-icons">image</i></span>
                      <i onClick={()=>{message !== null || src !== null ? sendMessage() : console.log("Error")}} className="mb-0 btn btn-primary ml-2"><i style={{fontSize: "18px"}} className="material-icons">send</i></i>
                    </div>
                  </div>
                </div> : <div></div>}
              </div>
            </div>
          </div>

          </div>
    )

    async function setActiveChat(chat){
      getMessages(chat.chatId);
      setSelectedChat(chat);
      setMessage("");
      setImg('');
      setFile(null)
      // changeActiveMessages(chat)
    }

    async function changeActiveMessages(chat){
      try{
        await firebase.db.collection("Chats").doc(chat.chatId).collection("Mensajes").get().then((val)=>{
          val.docs.forEach((message)=>{
            firebase.db.collection("Chats").doc(chat.chatId).collection("Mensajes").doc(message.messageId).update({
              status: true
            })
          })
        })
      }catch(e){
        console.log(e)
      }
    }

    async function sendMessage(){
      try{
        let id = firebase.db.collection("Chats").doc(selectedChat.chatId).collection("Mensajes").doc().id
        if(file !== null){
          
          await firebase.storage.ref(`/Chats imagenes/${file.name}`).put(file)
          firebase.storage.ref("Chats imagenes").child(file.name).getDownloadURL().then((uri)=>{
            firebase.db.collection("Chats").doc(selectedChat.chatId).collection("Mensajes").doc(id).set({
              messageId: id,
              aliadoId: user.aliadoId,
              uid: null,
              status: false,
              message: message,
              image: uri,
              createdOn: moment().toDate(),
            })
          })
          
        }else{
          
          await firebase.db.collection("Chats").doc(selectedChat.chatId).collection("Mensajes").doc(id).set({
            messageId: id,
            aliadoId: user.aliadoId,
            uid: null,
            status: false,
            message: message,
            image: null,
            createdOn: moment().toDate(),
          })

        }

        setMessage("")
        setImg('')
        setFile(null)
        getMessages(selectedChat.chatId)
        setDueñosInfo(aliadoChats)
        dummy.current.scrollIntoView({ behavior: 'smooth' });
      }catch(e){
        console.log(e)
      }
    }
    
}


export default Messages
